import { html } from 'lit';
const Readwise =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M11.226 3c4.959 0 7.55 1.043 7.55 4.71 0 2.776-1.35 4.1-4.067 4.558l3.65 5.935c.643 1.07 1.167 1.426 2.24 1.554v1.07h-5.293l-4.96-8.277H9.108v5.425c0 1.452.36 1.654 1.886 1.782v1.07H3v-1.07c1.526-.128 1.886-.333 1.886-1.782V5.853c0-1.476-.312-1.655-1.886-1.783V3zM9.04 10.844c1.313-1.092 5.29-1.11 5.29-1.11a.395.395 0 0 0 .31-.404c-.005-.034-.647-3.65-.228-4.42z"/>
  </svg>
`;
export default Readwise;
